import { escapeRegExp } from './stringUtils'
import { isEmpty } from './validationUtils'

export const keepOnlyNumberCharacters = (val = '', decimalSeparator = '.') => {
  const numRegex = new RegExp(`\\\\d|${escapeRegExp(decimalSeparator)}`, 'g')
  return (val.match(numRegex) || []).join('').replace(decimalSeparator, '.')
}

export const splitDecimal = (number: string) => {
  const parts = number.split('.')
  const integerPart = parts[0]
  const fractionalPart = parts[1] || ''
  return {
    integerPart,
    fractionalPart,
  }
}

export const limitLength = (number: string, length: number) => {
  return number.substring(0, length)
}

export const formatDecimalNumber = (num = '', maxDecimals = 2, decimalSeparator = '.') => {
  if (isEmpty(num)) return num

  const rawFloat = String(keepOnlyNumberCharacters(num, decimalSeparator))

  const floatWithoutExtraDecimals =
    decimalSeparator && maxDecimals === 0 ? rawFloat.split(decimalSeparator)[0] : rawFloat

  const normalizedFloat =
    floatWithoutExtraDecimals.charAt(0) === '.'
      ? `0.${floatWithoutExtraDecimals.substring(1)}`
      : floatWithoutExtraDecimals

  const parts = normalizedFloat.split('.')
  const cleanedFloat = parts.length > 1 ? `${parts[0]}.${parts.slice(1).join('')}` : normalizedFloat

  const { integerPart, fractionalPart: rawFractionalPart } = splitDecimal(cleanedFloat)

  const fractionalPart = maxDecimals !== undefined ? limitLength(rawFractionalPart, maxDecimals) : rawFractionalPart

  const hasDecimalSeparator = cleanedFloat.indexOf('.') !== -1

  return integerPart + ((hasDecimalSeparator && decimalSeparator) || '') + fractionalPart
}

export const formatCharactersHTMLtoString = (string: string) => {
  if (isEmpty(string)) return string
  const regex = /(&#[1-9]*1?;)/gi
  const numberPattern = /\d+/g

  const regExpMatchArray = string.match(regex)
  if (!regExpMatchArray) return string

  const numberCharacter = regExpMatchArray.join()
  const matches = numberCharacter.match(numberPattern)
  const characterHtml = matches ? String.fromCharCode(parseInt(matches.join(), 10)) : ''

  return string.replace(numberCharacter, characterHtml)
}

export const formatStringToFloat = (string: string, maxDecimals = 2) => {
  return parseFloat(parseFloat(string).toFixed(maxDecimals))
}

export const randomNumber = (min = 1, max = 100) => {
  return min + Math.random() * (max - min)
}

export const fixDecimals = (number: number, maxDecimals = 2) => {
  return number.toFixed(maxDecimals)
}
